import { render, staticRenderFns } from "./tradesmantouserform.vue?vue&type=template&id=2ac04a37&scoped=true&"
import script from "./tradesmantouserform.vue?vue&type=script&lang=js&"
export * from "./tradesmantouserform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac04a37",
  null
  
)

export default component.exports